<div class="options-payment-sip">

  <div *ngIf="config?.showOptionBackBtn" class="options-payment-sip-header">
    <button class="options-payment-sip-back-btn" (click)="back()" mat-button>
      <i class="material-icons">arrow_back_ios</i> <span>Back</span>
    </button>
    <div class="title">Enter Your Payment Details</div>
  </div>

  <!-- top bank list start -->
  <div *ngIf="config?.showTopBank && config?.paymentDetails?.selected_currency=='INR'" class="top-bank-list">
    <app-payment-sip-top-bank-listing [config]="config"></app-payment-sip-top-bank-listing>
  </div><!-- top bank list end -->

  <!-- top bank list start -->
  <div *ngIf="config?.showPaySwitch" class="pay-switch">
    <app-payment-sip-switch-pay-button [config]="config" (paySwitchEmit)="paySwitchEmit.emit($event)"></app-payment-sip-switch-pay-button>
  </div>
  <!-- top bank list end -->

  <!-- heading list start -->
  <div *ngIf="!config?.showOptionBackBtn" class="heading">
    <div class="title" [innerHtml]="config?.paymentOptionsTitle"></div>
  </div>
  <!-- heading list end -->

  <div class="option-selected" [ngClass]="{'hide-tab-header': config?.visibleTabs?.length===1}">
    <mat-tab-group [disableRipple]="true" (selectedTabChange)="selectOpTab($event)" [selectedIndex]="config?.visibleTabs?.indexOf(config?.selectedTab)" dynamicHeight>
      <mat-tab *ngFor="let item of config?.visibleTabs">
        <!-- tab buttons start -->
        <ng-template mat-tab-label>
          <span class="recommended" *ngIf="item.recommended">RECOMMENDED</span>
          <div class="tab-label" mat-ripple>
            <i [class]="item.icon"></i>
            <div class="label">{{item.label}}</div>
          </div>
        </ng-template><!-- tab buttons end -->

        <!-- tab preferred note start -->
        <div *ngIf="config?.paymentDetails?.selected_currency=='INR' && !config?.hideRecommendedNote" class="option-preferred-note inr-only">
          <i [class]="config?.selectedTab?.recommended ? config?.recommended?.preferred_icon : config?.nonRecommended?.preferred_icon"></i>
          <span>{{config?.selectedTab?.recommended ? config?.recommended?.preferred_text : config?.nonRecommended?.preferred_text+' '+config?.recommended?.label}}</span>
        </div><!-- tab preferred note end -->

        <!-- payment forms start -->
        <div class="option-template">
          <ng-container *ngTemplateOutlet="optionsRef; context: { option: item}"></ng-container>
        </div><!-- payment forms end -->
      </mat-tab>

    </mat-tab-group>

    <!-- payment service start -->
    <div class="payment-button">
      <app-payment-sip-button [config]="config" (btnClick)="paymentV2.pledgeBtn.next(config?.selectedTab?.name)"></app-payment-sip-button>
    </div><!-- payment service end -->

    <!-- bottom note start -->
    <div *ngIf="!config?.hideNote && config?.selectedTab?.note" class="note">
      <strong>Note: </strong> <span>{{config?.selectedTab?.note}}</span>
    </div><!-- bottom note end -->
  </div>
</div>


<!-- payment forms start -->
<ng-template #optionsRef let-option="option">
  <div *ngIf="option?.name=='card'">
    <app-payment-sip-card [config]="config" (dataEmit)="dataEmit.emit($event)"></app-payment-sip-card>
  </div>

  <div *ngIf="config?.paymentDetails?.selected_currency=='INR'" class="inr-only">
    <div *ngIf="option?.name=='bank'">
      <app-payment-sip-emandate [config]="config" (dataEmit)="dataEmit.emit($event)"></app-payment-sip-emandate>
    </div>

    <div *ngIf="option?.name=='wallet'">
      <app-payment-sip-wallet [config]="config" (dataEmit)="dataEmit.emit($event)"></app-payment-sip-wallet>
    </div>

    <div *ngIf="option?.name=='upi'">
      <app-payment-sip-upi [config]="config" (dataEmit)="dataEmit.emit($event)"></app-payment-sip-upi>
    </div>
  </div>
</ng-template><!-- payment forms end -->

<app-module-loader [moduleId]="'leave-confirmation-dm'" [selector]="'app-leave-confirmation-dm'" [load]="showIntent" [inputs]="{currency: config?.currency}" [outputs]="{popupshow: popupshow}"></app-module-loader>